var checkListSection = document.querySelector('.collection-product-list-alpha')

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    // SV-
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.body.addEventListener('FacetFilters:submit:ajax', debounce((e) => {
      if (e.detail.form.id !== facetForm.id) return;
      console.log('e.detail.searchParams', e.detail.searchParams)
      FacetFiltersForm.renderPage(e.detail.searchParams, e);
    }, 100));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    window.addEventListener('change', (e) => {
      console.log('change event e.target: ', e.target)
      if (e.target.closest('[name="sort_by"]')) {
        console.log('passed check for [name="sort_by"] ', e.target)
        e.preventDefault(); // Stop the form from reloading the page
        console.log('change event for [name="sort_by"]', e)
        const sort_by = e.target.value;
        const url = window.location.pathname + '?sort_by=' + sort_by;
        const the_form = e.target.closest('form')

        let searchParams = new URLSearchParams(new FormData(the_form));
        // remove blank values
        let paramsToDelete = [];
        searchParams.forEach((value, key) => {
          if (value == '') {
            paramsToDelete.push(key);
          }
        });
        paramsToDelete.forEach(key => {
          searchParams.delete(key);
        });
        let current_url = new URL(window.location);
        let current_url_params = new URLSearchParams(current_url.search);
        console.log('current_url_params', current_url_params)
        current_url_params.delete('sort_by')
        let updated_params = current_url_params.toString();
        if (updated_params.charAt(0) === '?') {
          updated_params = updated_params.substring(1)
        }
        
        console.log('current_url', typeof current_url)
        const new_params = searchParams.toString();
        if (updated_params) {
          updated_params = updated_params + `&${new_params}`
        } else {
          updated_params = new_params;
        }
        let event_detail = {searchParams: updated_params, form: the_form};

        console.log('dispatching FacetFilters:submit:ajax from facets.js')
        document.body.dispatchEvent(new CustomEvent('FacetFilters:submit:ajax', { detail: event_detail }));
        
      }
    })
    
  }

  static updateSortTitle() {
    const current_sort = document.querySelectorAll('.current-sort');
    console.log('current_sort', current_sort)
    setTimeout(() => {
      if (current_sort.length > 0) {
        current_sort.forEach(el => {
          const current_sort_parent = el.closest('.radio-select')
          const current_sort_selection = current_sort_parent.querySelector('[name="sort_by"]:checked + label')
          console.log('current_sort:::', current_sort)
          if (current_sort_selection) {
            el.textContent = current_sort_selection.textContent;
            console.log('current_sort_selection', current_sort_selection)
          } else {
            el.textContent = current_sort_parent.querySelector('[name="sort_by"] + label')?.textContent;
            console.log('current_sort_parent', current_sort_parent)
          }
        })
      } 
    }, 100)


    // check url, update all 3 sorts with current value
    const desktop_sort = document.querySelectorAll('.facets-top-desktop [name="sort_by"]');
    const mobile_sort_1 = document.querySelectorAll('.sort-main-mobile [name="sort_by"]');
    const mobile_sort_2 = document.querySelectorAll('.mobile-facets__main [name="sort_by"]');
    let params = new URLSearchParams(document.location.search);
    let sort_by = params.get("sort_by");
    
    Array.from( desktop_sort ).forEach((element,index) => {
      if (sort_by === element.value) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
    Array.from( mobile_sort_1 ).forEach((element,index) => {
      if (sort_by === element.value) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
    Array.from( mobile_sort_2 ).forEach((element,index) => {
      if (sort_by === element.value) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
     
    
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('renderPage searchParams', searchParams)
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        // console.log('updating sort title')
        this.updateSortTitle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        // console.log('updating sort title from cache!')
        this.updateSortTitle();
  }

  static renderProductGridContainer(html) {
    // if (!checkListSection) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

      document
        .getElementById('ProductGridContainer')
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
    // } else {

      const parser = new DOMParser();

      // Parse the HTML string into a DOM Document object
      const results = parser.parseFromString(html, 'text/html');
      const list_items = results.querySelectorAll('#product-grid li')
      //console.log('list_items', list_items)
      let product_titles = []
      let product_handles = []
      let product_full_titles = []
      // console.log('product_titles', product_titles, ' product_handles ', product_handles, ' product_full_titles ', product_full_titles)
      if (list_items.length > 0) {
        list_items.forEach(el => {
          product_titles.push(el.dataset.title)
          product_handles.push(el.dataset.handle)
          product_full_titles.push(el.dataset.full_title)
        })
      }
      // console.log('product_titles', product_titles, ' product_handles ', product_handles, ' product_full_titles ', product_full_titles)
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("collection_updated", {bubbles: true}));
      }, 10)
      
    // }
    
  }

  static renderProductCount(html) {

    //if (!checkListSection) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
      console.log('count from facets.js', count)
      const container = document.getElementById('ProductCount');
      if (!container) return;
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner', '.collection .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }
  //}

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    // SV- prevent double firing
    if (event && event.type == 'input' && event.target.classList.contains('custom-select')) return;

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        document.getElementById(elementToRender.id).dataset.selected = elementToRender.dataset.selected; //SV-
        document.getElementById(elementToRender.id).dataset.exclude_values = elementToRender.dataset.exclude_values; //SV-
        document.getElementById(elementToRender.id).dataset.filter_values = elementToRender.dataset.filter_values;
        document.dispatchEvent(new Event('facets:updated')); //SV-
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    document.dispatchEvent(new Event('facets:updated2')); //SV-

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // console.log('update searchParams', searchParams)
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    console.log('sortFilterForms', sortFilterForms)
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        console.log('isMobile? in facets.js', isMobile)
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    console.log('from onActiveFilterClick', event.currentTarget.href.indexOf('?'))
    console.log('from onActiveFilterClick', event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1))
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.updateSortTitle();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    // SV-
    if (this.dataset.type == 'frame') {
      facetLink.addEventListener('click', (e) => {
        console.log('dispatching remove-frame')
        document.dispatchEvent(new CustomEvent('remove-frame'));
      });
    }
    
    if (this.dataset.close_filter_type == 'brand') {
      facetLink.addEventListener('click', (e) => {
        console.log('dispatching remove-brand')
        document.dispatchEvent(new CustomEvent('remove-brand'));
      });
    }

    if (this.dataset.close_filter_type == 'all') {
      facetLink.addEventListener('click', (e) => {
        const facet_parent = e.target.closest('a')
        let has_brand = facet_parent.href.includes('filter.p.m.product.brand')
        let clear_brand;
        has_brand ? clear_brand = false : clear_brand = true;
        
        console.log('clear_brand', clear_brand)
        let event_detail = {};
        event_detail.clear_brand = clear_brand;

        // reset alpha sort 
        const showAll = document.querySelector('[data-group_link="all"]');
        console.log('showAll::', showAll)
        if (showAll) showAll.click();
        
        console.log('dispatching remove-all', facet_parent)
        document.dispatchEvent(new CustomEvent('remove-all', { detail: event_detail }));
        document.dispatchEvent(new CustomEvent('remove-frame'));
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
